import { initProductCardHoverImages } from "./hover-image";
import { initProductCardMobileSlider } from "./mobile-slider";

export function initProductCards(root: ParentNode = document): void {
  initProductCardHoverImages(root);
  initProductCardMobileSlider();
}
